import { Button, Dialog, textVariants, Text } from '@etg/wings';
import { css, mediaQueries } from '@eti/styles';
import { useTranslation } from '@eti/providers';
import { CONFIRMATION_MODAL_REDIRECT_TO, CONFIRMATION_MODAL_TYPE, CONFIRMATION_MODAL_ACTION_TYPE } from '../utils/constants';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const backdropStyles = css`
  background: rgb(101 101 101 / 80%);
  height: 100%;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 11;
`;
const segmentsStyles = css`
  list-style: disc;
  margin: 12px 10px;
  padding-left: 14px;

  [dir='rtl'] & {
    padding-left: 0;
    padding-right: 14px;
  }
`;
const dividerStyles = css`
  margin: 0 2px;
`;
const buttonsWrapperStyles = css`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 5px;

  @media ${mediaQueries.large.up} {
    flex-direction: row;
  }
`;
const buttonStyles = css`
  flex: 1;
`;
const generateKey = (from, to, i) => `${from}-${to}-${i}`;
const SeatMapConfirmationDialog = _ref => {
  var _segments$0$boundSegm;
  let {
    onSelection,
    segments,
    redirectTo = CONFIRMATION_MODAL_REDIRECT_TO.DEFAULT,
    type = CONFIRMATION_MODAL_TYPE.SEAT_MAP_PERSIST_IN_PRODUCT_UNBOOKED_SEGMENTS
  } = _ref;
  const {
    t
  } = useTranslation();
  const title = t('Product.SeatMap.AllSeatsSelectedConfirmation.Title');
  const text = t('Product.SeatMap.AllSeatsSelectedConfirmation.Text');
  const dismissText = () => {
    switch (redirectTo) {
      case CONFIRMATION_MODAL_REDIRECT_TO.PAYMENT:
        return t('Product.SeatMap.AllSeatsSelectedConfirmation.Payment.DismissText');
      case CONFIRMATION_MODAL_REDIRECT_TO.SUMMARY:
        return t('Product.SeatMap.AllSeatsSelectedConfirmation.Summary.DismissText');
      case CONFIRMATION_MODAL_REDIRECT_TO.DEFAULT:
      default:
        return t('Product.SeatMap.AllSeatsSelectedConfirmation.DismissText');
    }
  };
  const onDismissPersistModal = () => {
    onSelection(CONFIRMATION_MODAL_ACTION_TYPE.SEAT_MAP_PERSIST_ACTION_DISMISS, null);
  };
  const acceptText = t('Product.SeatMap.AllSeatsSelectedConfirmation.AcceptText');
  const segmentIndex = segments.length > 0 ? (_segments$0$boundSegm = segments[0].boundSegmentIndex) !== null && _segments$0$boundSegm !== void 0 ? _segments$0$boundSegm : null : null;
  const getConfirmationContent = () => {
    switch (type) {
      case CONFIRMATION_MODAL_TYPE.SEAT_MAP_PERSIST_IN_PRODUCT:
        return /*#__PURE__*/_jsxs(Dialog, {
          closeButtonAriaLabel: t('ScreenReader.CloseButtonDialog.AriaLabel.Text'),
          isOpen: true,
          title: t('Product.SeatMap.Persist.Modal.Title'),
          children: [/*#__PURE__*/_jsx(Text, {
            asHtml: true,
            variant: textVariants._14_BOLD,
            children: t('Product.SeatMap.Persist.Modal.Text')
          }), /*#__PURE__*/_jsxs("div", {
            className: buttonsWrapperStyles,
            children: [/*#__PURE__*/_jsx(Button, {
              className: buttonStyles,
              "data-testid": "seatMap-persist-modal-dismiss",
              onClick: onDismissPersistModal,
              children: t('Product.SeatMap.Persist.Modal.Actions.Accept')
            }), /*#__PURE__*/_jsx(Button, {
              className: buttonStyles,
              "data-testid": "seatMap-persist-modal-accept",
              onClick: () => onSelection(CONFIRMATION_MODAL_ACTION_TYPE.SEAT_MAP_PERSIST_ACTION_ACCEPT, segmentIndex),
              variant: "primary",
              children: t('Product.SeatMap.Persist.Modal.Actions.Dismiss')
            })]
          })]
        });
      case CONFIRMATION_MODAL_TYPE.SEAT_MAP_PERSIST_IN_PRODUCT_UNBOOKED_SEGMENTS:
      default:
        return /*#__PURE__*/_jsxs(Dialog, {
          closeButtonAriaLabel: t('ScreenReader.CloseButtonDialog.AriaLabel.Text'),
          isOpen: true,
          title: title,
          children: [/*#__PURE__*/_jsx(Text, {
            variant: textVariants._14,
            children: text
          }), /*#__PURE__*/_jsx("ul", {
            className: segmentsStyles,
            children: segments.map((_ref2, i) => {
              let {
                from,
                to
              } = _ref2;
              return /*#__PURE__*/_jsxs("li", {
                children: [from.city, " ", /*#__PURE__*/_jsx(Text, {
                  variant: textVariants._12_BOLD,
                  children: from.iata
                }), /*#__PURE__*/_jsx(Text, {
                  className: dividerStyles,
                  children: "\u2013"
                }), to.city, " ", /*#__PURE__*/_jsx(Text, {
                  variant: textVariants._12_BOLD,
                  children: to.iata
                })]
              }, generateKey(from, to, i));
            })
          }), /*#__PURE__*/_jsxs("div", {
            className: buttonsWrapperStyles,
            children: [/*#__PURE__*/_jsx(Button, {
              className: buttonStyles,
              "data-testid": "seatMap-allSeatsSelectedConfirmation-dismiss",
              onClick: () => onSelection(CONFIRMATION_MODAL_ACTION_TYPE.SEAT_MAP_PERSIST_ACTION_DISMISS, null),
              children: dismissText()
            }), /*#__PURE__*/_jsx(Button, {
              className: buttonStyles,
              "data-testid": "seatMap-allSeatsSelectedConfirmation-accept",
              onClick: () => onSelection(CONFIRMATION_MODAL_ACTION_TYPE.SEAT_MAP_PERSIST_ACTION_ACCEPT, segmentIndex),
              variant: "primary",
              children: acceptText
            })]
          })]
        });
    }
  };
  return /*#__PURE__*/_jsx("div", {
    className: backdropStyles,
    "data-testid": `seatMap-persist-modal-${type}`,
    children: getConfirmationContent()
  });
};
export default SeatMapConfirmationDialog;
//# sourceMappingURL=SeatMapConfirmationDialog.js.map